<template>
  <div>

    <div class='notification'>
      <img v-if='value.image.filename !== ""' :src='static + value.image.filename' style='width: 100%;' />
      <div v-else>Нет фотографии</div>
      <button class="button is-margin-top" @click='is_taking_photo=true'>Сфотографировать</button>
    </div>

    <b-modal :active.sync='is_taking_photo' :width='1280' :height='720' scroll='keep'>
      <div class="card">
        <div class="card-content">
          <webcam ref="webcam" class='webcam' :width='700'></webcam>
          <button class='button' type="button" @click='photo()'>Сфотографировать</button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
  import webcam from './webcam'

  export default {
    name: 'photo',
    props: {
      value: {
        type: Object,
        default: function () {
          return this.empty_media
        }
      }
    },
    components: {
      webcam
    },
    data: function () {
      return {
        static: window.static,
        p: null,
        is_taking_photo: false,
        empty_media: {audio: {name: '', filename: '', filetype: '', filesize: 0}, video: {name: '', filename: '', filetype: '', filesize: 0}, image: {name: '', filename: '', filetype: '', filesize: 0}}
      }
    },
    methods: {
      u_name: function () {
        return '_' + Math.random().toString(14).substr(2, 9)
      },
      prepare_file: function () {
        var p = this.$refs.webcam.capture()
        this.is_taking_photo = false
        // p = p.replace('data:image/jpeg;base64,', '')
        p = atob(p.split(',')[1])
        var ab = new ArrayBuffer(p.length)
        var ia = new Uint8Array(ab)
        for (var i = 0; i < p.length; i++) {
          ia[i] = p.charCodeAt(i)
        }
        var file = {}
        file.name = this.u_name() + '.jpeg'
        file.size = p.length
        file.type = 'image/jpeg'
        file.data = new Blob([ab], {type: 'image/jpeg'})
        return file
      },
      photo: function () {
        var _this = this
        var xhr = new XMLHttpRequest()
        var file = this.prepare_file()
        xhr.open('PUT', window.gw + 'api/upload/' + file.name, true)
        xhr.setRequestHeader('Content-Type', file.type)
        xhr.setRequestHeader('Content-Range', `bytes 0-${file.size - 1}/${file.size}`)
        xhr.onload = (e) => {
          console.log('upload complete', e)
          var d = JSON.parse(e.currentTarget.response)
          if (d.result === 'ok') {
            var f = d.params.file
            _this.value.image.name = f.real_filename
            _this.value.image.filename = f.filename
            _this.value.image.filesize = f.filesize
            _this.value.image.filetype = f.filetype
            _this.$emit('input', _this.value)
            console.log(_this.value)
          }
          // _this.progress['image'].loading = false
        }
        xhr.onerror = (e) => {
          console.log('upload error', e)
          // _this.progress['image'].loading = false
        }
        xhr.send(file.data)
      }
    }
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Photo.vue